<template>
  <div class="mx-auto mt-5 mb-10 md:max-w-2xl" v-if="companies">
    <h1
      class="font-sans text-xl font-semibold text-center md:text-center md:font-bold md:text-3xl"
    >
      Featured Agencies
    </h1>
  </div>
  <div class="max-w-5xl mx-auto mt-5 mb-10" responsive ref="horizontal">
    <div class="carousel">
      <vue-horizontal snap="center" ref="horizontal" class="p-10 horizontal">
        <template v-slot:btn-prev>
          <PrevSvg color="primary" height="44" width="44" />
        </template>
        <template v-slot:btn-next>
          <NextSvg color="primary" height="44" width="44" />
        </template>

        <div class="flex flex-row justify-center space-x-4 md:space-x-24">
          <a
            :href="
              $router.resolve({
                name: 'CompanyView',
                params: {
                  id: company.id,
                  slug: company.name ? $sanitizeTitle(company.name) : '',
                },
              }).href
            "
            class=""
            v-for="(company, index) in companies"
            :key="index"
          >
            <img
              v-if="company.photo"
              :src="company.photo"
              class="h-[5rem]"
              alt=""
            />
          </a>
        </div>
      </vue-horizontal>
    </div>
  </div>
</template>
<script>
import VueHorizontal from "vue-horizontal";
import NextSvg from "@/components/svg/NextSvg.vue";
import PrevSvg from "@/components/svg/PrevSvg.vue";
import axios from "axios";
export default {
  name: "FeaturedAgencies",
  components: {
    VueHorizontal,
    NextSvg,
    PrevSvg,
  },
  data() {
    return {
      base_url: this.$store.state.baseUrl,
      companies: null,
    };
  },
  mounted() {
    axios
      .get(`${this.base_url}companies`)
      .then((response) => {
        this.companies = response.data.data;
      })
      .catch((error) => console.log(error));
  },
};
</script>
<style scoped>
.horizontal >>> .v-hl-btn svg {
  padding: 3px;
  height: 10rem;
  width: 10rem;
}
</style>
